// extracted by mini-css-extract-plugin
export default {"notAuthContainer":"styles_notAuthContainer__obDzV","message":"styles_message__YXlWo","icon":"styles_icon__g9r+E"};